module.exports = __webpack_public_path__ + "static/media/offers-hero.c0ced17b.jpg";